import { useState } from 'react';
import { useSubscription, PlanType } from '../contexts/SubscriptionContext';

interface PaywallConfig {
  feature: string;
  description: string;
  requiredPlan: PlanType;
}

export const usePaywall = () => {
  const [paywall, setPaywall] = useState<PaywallConfig | null>(null);
  const { subscription, hasFeature } = useSubscription();

  const checkFeatureAccess = (
    feature: keyof typeof import('../contexts/SubscriptionContext').plans.basic,
    config: PaywallConfig
  ): boolean => {
    if (hasFeature(feature)) {
      return true;
    }

    setPaywall(config);
    return false;
  };

  const checkReelLimit = (): boolean => {
    if (!subscription) {
      setPaywall({
        feature: 'Create Reels',
        description: 'You need an active subscription to create reels.',
        requiredPlan: 'basic',
      });
      return false;
    }

    if (subscription.plan.reelsLimit === -1) {
      return true; // Unlimited
    }

    if (subscription.reelsUsedThisMonth >= subscription.plan.reelsLimit) {
      setPaywall({
        feature: 'Reel Limit Reached',
        description: `You've reached your monthly limit of ${subscription.plan.reelsLimit} reels. Upgrade to create more reels this month.`,
        requiredPlan: subscription.plan.type === 'basic' ? 'pro' : 'enterprise',
      });
      return false;
    }

    return true;
  };

  const closePaywall = () => setPaywall(null);

  return {
    paywall,
    checkFeatureAccess,
    checkReelLimit,
    closePaywall,
  };
};